 <template>
  <card>
    <b-row>
      <b-col cols="10">
        <b-form class="row" v-on:submit.prevent="doFilter">
          <b-col md="4">
            <el-input class="input-primary" placeholder="Filter By Name" clearable v-model="tableFilter.name"/>
          </b-col>
          <!-- <b-col md="3">
            <el-input class="input-primary" placeholder="Filter By Created By" clearable v-model="tableFilter.createdBy"/>
          </b-col> -->
          <b-col md="7">
            <el-date-picker
              v-model="tableFilter.date"
              type="daterange"
              placeholder="Pick a range">
            </el-date-picker>
          </b-col>
          <b-col md="1">
            <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/> Search</button>
          </b-col>
          <b-col md="3 pl-3">
            <fg-input class="mt-2">
              <treeselect 
                v-model="tableFilter.size" 
                class="mb-3" 
                placeholder="Pilih ukuran" 
                :multiple="false"
                :clear-on-select="true"
                :options="sizeList"
                name="size"
                data-vv-as="size" ></treeselect>
            </fg-input>
          </b-col>
          <b-col md="4">
            <fg-input class="mt-2">
              <treeselect 
                v-model="tableFilter.color" 
                class="mb-3" 
                placeholder="Pilih warna" 
                :multiple="false"
                :clear-on-select="true"
                :options="colorList" 
                name="color"
                data-vv-as="color"
              ></treeselect>
            </fg-input>
          </b-col>
          <b-col md="4 pl-3">
            <fg-input class="mt-2">
              <treeselect 
                v-model="tableFilter.reasonModel" 
                class="mb-3" 
                placeholder="Pilih alasan" 
                :multiple="false"
                :clear-on-select="true"
                :options="reasonList"
                name="size"
                data-vv-as="size" ></treeselect>
            </fg-input>
          </b-col>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :can-delete="false" :param-no-uuid="true"  :active-url="apiUrl" :data-url="apiUrl" :data-key="dataKey" :can-edit="false" :no-actions="true" :can-show="false" :data-columns="columns" :data-params="['is_active', 'reason','name','color_id', 'size_id','start_date', 'end_date', 'color_id']">
      <template slot="content_created_by" slot-scope="defaultSlotScope">
        <a :href="'#/users/' + defaultSlotScope.rowData.created_by.id">{{defaultSlotScope.rowData.created_by.name}}</a>
      </template>
      <template slot="content_reason" slot-scope="defaultSlotScope">
        {{defaultSlotScope.rowData.reason !== null ? defaultSlotScope.rowData.reason : '-'}}
      </template>
      <template slot="content_last_updated_by" slot-scope="defaultSlotScope">
        <a :href="'#/users/' + defaultSlotScope.rowData.last_updated_by.id">{{defaultSlotScope.rowData.last_updated_by.name}}</a>
      </template>
      <template slot="content_stock_now" slot-scope="defaultSlotScope">
        <span v-if="defaultSlotScope.rowData.stock_in > 0">{{defaultSlotScope.rowData.stock - defaultSlotScope.rowData.stock_in }}</span>
        <span v-else>{{defaultSlotScope.rowData.stock + defaultSlotScope.rowData.stock_out }}</span>
      </template>
      <template slot="content_product" slot-scope="defaultSlotScope">
        {{defaultSlotScope.rowData.product_size.product_color.product_categories.product.name}} - 
        {{defaultSlotScope.rowData.product_size.product_color.color.name}} - {{defaultSlotScope.rowData.product_size.size.name}}
      </template>
    </paginated-table>
  </card>
</template>
<script>
  import { Input, Checkbox, DatePicker } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import CreateNewData from '@/components/Buttons/CreateNewData'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      [DatePicker.name]: DatePicker,
      CreateNewData,
      Treeselect,
      elCheckbox: Checkbox
    },
    data () {
      return {
        dataKey: 'stock',
        apiUrl: window.AppConfig.apiUrl + 'stock',
        apiUrlCollection: {
          color: window.AppConfig.apiUrl + 'color',
          size: window.AppConfig.apiUrl + 'size'
        },
        reasonList: [
          {
            id: '',
            label: 'Semua Alasan'
          },
          {
            id: 'Reject',
            label: 'Reject'
          },
          {
            id: 'Rusak',
            label: 'Rusaks'
          },
          {
            id: 'Salah Barang',
            label: 'Salah Barang'
          },
          {
            id: 'Miss Stock',
            label: 'Miss Stock'
          },
          {
            id: 'Giveaway',
            label: 'Giveaway'
          },
          {
            id: 'Adjutment',
            label: 'Adjutment'
          },
          {
            id: 'Stock Dikosongkan',
            label: 'Stock Dikosongkan'
          },
          {
            id: 'PLUS STOCK',
            label: 'PLUS STOCK'
          }
        ],
        columns: [
          {
            prop: 'product',
            label: 'Barang'
          },
          {
            prop: 'stock_now',
            label: 'Stock Saat Ini',
            sortable: true,
            align: 'right'
          },
          {
            prop: 'stock_in',
            label: 'Stock Masuk',
            align: 'right'
          },
          {
            prop: 'stock_out',
            label: 'Stock Keluar',
            align: 'right'
          },
          {
            prop: 'stock',
            label: 'Stock Akhir',
            sortable: true,
            align: 'right'
          },
          {
            prop: 'reason',
            label: 'Alasan',
            sortable: true
          },
          {
            prop: 'created_at',
            label: 'Tgl',
            sortable: true
          },
          // {
          //   prop: 'created_by',
          //   label: 'Dibuat oleh'
          // },
          {
            prop: 'last_updated_by',
            label: 'Diperbarui Oleh'
          }
        ],
        colorList: [],
        sizeList: [],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          name: this.$route.query.name,
          createdBy: null,
          size: null,
          color: null,
          reasonModel: null,
          color_id: this.$route.query.color_id,
          reason: this.$route.query.reason,
          size_id: this.$route.query.size_id,
          created_by: this.$route.query.created_by,
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          date: null
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      getColor () {
        this.$http.get(this.apiUrlCollection.color + '?limit=100').then(response => {
          this.colorList = []
          response.data.data.forEach(data => {
            this.colorList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      getSize () {
        this.$http.get(this.apiUrlCollection.size + '?limit=100').then(response => {
          this.sizeList = []
          response.data.data.forEach(data => {
            this.sizeList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      doFilter () {
        this.tableFilter.created_by = this.tableFilter.createdBy !== null ? this.tableFilter.createdBy : null
        this.tableFilter.color_id = this.tableFilter.color !== null && this.tableFilter.color !== undefined ? this.tableFilter.color : null
        this.tableFilter.reason = this.tableFilter.reasonModel !== null && this.tableFilter.reasonModel !== undefined ? this.tableFilter.reasonModel : null
        this.tableFilter.size_id = this.tableFilter.size !== null && this.tableFilter.size !== undefined ? this.tableFilter.size : null
        this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
        this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      getColorStatus (status) {
        if (status === 'Canceled') {
          return 'dark'
        } else if (status === 'Paid') {
          return 'success'
        } else if (status === 'Invoice') {
          return 'primary'
        } else if (status === 'Working') {
          return 'warning'
        } else if (status === 'New') {
          return 'info'
        } else {
          return 'danger'
        }
      }
    },
    mounted () {
      // this.initData().requestCategory()
      this.getColor()
      this.getSize()
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/StockIn/Index.vue